import { AfterViewInit, Directive, ElementRef, Input, OnDestroy, Renderer2 } from "@angular/core";
import { MedLocalizationService } from "@mk/med-localization";

import { STRING } from "../constants/string";
import { TEST_ID_ATTR } from "../constants/attributes";
import { ABNORMAL_TAGS } from "../constants/abnormal-tags";

@Directive({
  selector: "[medE2eTestId]",
})
export class MedE2eTestIdDirective implements OnDestroy, AfterViewInit {
  constructor(
    private _elRef: ElementRef,
    private _renderer: Renderer2,
    private localization: MedLocalizationService,
  ) {
    const { tagName, classList } = this._nativeEl;
    this._elName = this._isNativeEl() ? classList[0] || tagName : tagName;
  }

  private readonly _elName: string;
  private subscription: any;

  @Input() medE2eTestId?: string;

  private get _nativeEl(): HTMLElement {
    return this._elRef.nativeElement;
  }

  ngAfterViewInit(): void {
    this.subscription = this.localization.loading$.subscribe((loading: any) => {
      if (!loading) {
        const toEncode = this.getParent(this._elRef.nativeElement, this._elName);
        const encodedPart = this.simpleHash(toEncode);
        this._renderer.setAttribute(
          this._nativeEl,
          TEST_ID_ATTR,
          this.medE2eTestId ?
            this.medE2eTestId.split(STRING.SPACE).join(STRING.DASH).concat(STRING.DASH, this._elName)
            : this._elName.concat(STRING.DASH, encodedPart),
        );
      }
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  private _isNativeEl(): boolean {
    const { tagName } = this._nativeEl;
    return !tagName.includes(STRING.MINUS) || ABNORMAL_TAGS.includes(tagName);
  }

  private getParent(element: any, accum: string): string {
    try {
      if (element.parentElement) {
        return this.getParent(element.parentElement, accum.concat(element.tagName));
      }
      return accum;
    } catch (e) {
      return accum;
    }
  }

  private simpleHash(str: string): string {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      const char = str.charCodeAt(i);
      // eslint-disable-next-line no-bitwise
      hash = (hash << 5) - hash + char;
      // eslint-disable-next-line no-bitwise
      hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([hash])[0].toString(36);
  }
}
